<div class="breadcrumb-container">
  <ion-grid fixed="true">
    <ion-row class="breadcrumb-row">
      <ion-col>
        <a routerLink="/" class="breadcrumb-item">Home</a>
        <img
          src="assets/icon/breadcrumb-chevron.svg"
          alt="chevron-right"
          class="breadcrumb-separator"
        />
        <a routerLink="/customer-reporting" class="breadcrumb-item"
          >Business Analytics</a
        >
        <img
          src="assets/icon/breadcrumb-chevron.svg"
          alt="chevron-right"
          class="breadcrumb-separator"
        />
        <span class="breadcrumb-item active">{{ activePageName }}</span>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
